import { RouterItem } from '@/utils/interfaces';

/** 根据roles过滤路由 route.meta.permission */
export function filterRoutesByRole(arrRouter: RouterItem[], userRoles: string[]) {
  const accessedRouters = arrRouter.filter(route => {
    if (hasPermission(route, userRoles)) {
      if (route.children && route.children.length > 0) {
        route.children = route.children.filter(child => {
          if (hasPermission(child, userRoles)) {
            return child;
          }

          return false;
        });

        return route;
      }
      return route;
    }
    return hasPermission(route, userRoles);
  });
  return accessedRouters;
}

function hasPermission(route: RouterItem, roles: string[]) {
  if (route.meta) {
    if (route.meta.authorize) {
      const permission = route.meta.authorize;
      if (route.path == 'user') {
        console.log('user-route', route);
      }
      // console.log(`%c ${route.meta.title}设置的权限---${permission}`, 'color:red')
      if (Array.isArray(permission)) {
        let value = (permission as string[]).some(o => roles.indexOf(o) >= 0);
        console.log('permission-value', value);
        return value;
      }

      if (typeof permission === 'function') {
        const r = permission.apply(null);
        return r;
      }
      return false;
    }
    return true;
  }
  return true;
}
